import React, { useState, useEffect, useRef } from 'react';

function DemoWithIntro () {

    const [frame1, setFrame1] = useState('');
    const [frame2, setFrame2] = useState('');
    const [frame3, setFrame3] = useState('');

    

    useEffect(() => {
      setFrame1(window.location.origin + '/app/game/?demo=true&player=1');
      setFrame2(window.location.origin + '/app/game/?demo=true&player=2');
      setFrame3(window.location.origin + '/app/game/?demo=true&player=3');

      document.body.classList.add('demo-body');
    }, []);
    return (
        <div className="demoContainer">
            <div className="demoColumn">
              <iframe className="demoFrame" src={frame1} width="100%" height="100%" >
                <p>loading....</p>
              </iframe>
            </div>
            <div className="demoColumn">
              <iframe className="demoFrame" src={frame2} width="100%" height="100%">
                <p>loading....</p>
              </iframe>
            </div>
            <div className="demoColumn">
              <iframe className="demoFrame" src={frame3} width="100%" height="100%">
                <p>loading....</p>
              </iframe>
            </div>
        </div>
    )
}

export default DemoWithIntro;